<template>
	<span v-html="parseLegalText"> </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters(['getEvent']),
		parseLegalText() {
			if (this.getEvent.legaltext) {
				return this.getEvent.legaltext.split('\n').join('<br>');
			} else {
				return '';
			}
		}
	}
};
</script>

<style></style>
